import { render, staticRenderFns } from "./Image.vue?vue&type=template&id=3ba50a1b"
import script from "./Image.vue?vue&type=script&lang=js"
export * from "./Image.vue?vue&type=script&lang=js"
import style0 from "./Image.vue?vue&type=style&index=0&id=3ba50a1b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports